module.exports = __webpack_public_path__ + "img/BDG.3ddb196.svg";